import React, { useRef } from 'react'
import useSWR from 'swr'
import MerchandiseItem from './item'
import useBasketModel from '@lib/basket-model'

const fetcher = url => fetch(url).then(res => res.json())

const countBasketItems = basketData => {
  if (!basketData?.merchandiseItems) return {}

  const counts = {}
  basketData.merchandiseItems.forEach(item => {
    const stockItemId = item.stockItem?.id
    if (stockItemId) {
      counts[stockItemId] = (counts[stockItemId] || 0) + 1
    }
  })
  return counts
}

const EventMerchandise = ({ eventId }) => {
  const { data: event } = useSWR(`/events/${eventId}.json`, fetcher)
  const basket = useBasketModel()

  const basketCounts = useRef({})
  basketCounts.current = countBasketItems(basket.data)

  if (!event) {
    return (
      <div className='text-gray-600 dark:text-gray-400'>
        Loading merchandise...
      </div>
    )
  }

  if (!event.merchandise || event.merchandise.length === 0) {
    return null
  }

  return (
    <div className='flex flex-col space-y-4 py-2'>
      <div className='flex flex-col space-y-2'>
        <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>
          Available Merchandise for {event.name}
        </h3>
        {event.merchandise_info && (
          <div
            className='text-sm text-gray-600 dark:text-gray-400'
            dangerouslySetInnerHTML={{ __html: event.merchandise_info }}
          />
        )}
      </div>

      <div className='grid gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'>
        {event.merchandise.map(item => (
          <MerchandiseItem
            key={item.spektrix_v3_id || item.spektrix_id}
            item={item}
            basketCounts={basketCounts.current}
            isLoading={basket.isLoading}
            hasStock={item.stock_level > 0}
          />
        ))}
      </div>
    </div>
  )
}

export default EventMerchandise
